import { IThunderboltEntry } from '@wix/editor-elements-types';

import {
  registerComponentTypeUiTypes,
  UiTypesRegistrationMap,
} from '../../registration/registration';

const UiTypes: UiTypesRegistrationMap = {
  '': () => [
    import('./viewer/ComboBoxInput' /* webpackChunkName: "ComboBoxInput" */),
    import(
      './viewer/ComboBoxInput.controller' /* webpackChunkName: "ComboBoxInput" */
    ),
  ],
};

const entry: IThunderboltEntry = {
  loadComponent: registerComponentTypeUiTypes('ComboBoxInput', UiTypes),
};

export default entry;
